// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","271":"component---src-pages-donations-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"332d900a9f253cd9693d","271":"7139c02340ae0cd349d7","691":"3167f4bb345fcf98d48d"}[chunkId] + ".js";
};